module.exports = __webpack_public_path__ + "img/poseCVCMidAvecAide.5e5303f8.jpg";